import { FC, useEffect } from 'react';

type Props = {
  title?: string;
};

export const LightHelmet: FC<Props> = ({ title }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return null;
};
